/*
 * Información de la orden de traspaso.
 *
 * Your description here.
 *
 * Created on Tue Jun 13 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>

    <!-- #region::Transfer information -->
    <b-card>
      <b-card-text>
        <b-form-row>
          <b-col md="12">
            <h4>Información del traspaso</h4>
          </b-col>

          <!-- #region::Origin select -->
          <b-col md="4">
            <SelectWithValidation
              v-model="selectedOrigin"
              vid="selectedOrigin"
              rules="required"
              name="origen"
              label="Origen"
              property="text"
              placeholder="Selecciona el origen"
              :options="filteredOriginLocations"
              :disabled="areAvailableProducts"
            />
          </b-col>
          <!-- #endregion::Origin select -->

          <!-- #region::Destination select -->
          <b-col md="4">
            <SelectWithValidation
              v-model="selectedDestination"
              vid="selectedDestination"
              rules="required"
              name="destino"
              label="Destino"
              property="text"
              placeholder="Selecciona el destino"
              :options="filteredDestinationLocations"
            />
          </b-col>
          <!-- #endregion::Destination select -->

          <!-- #region::Arrive date picker -->
          <b-col
            md="4"
            class="mt-50"
          >
            <DatePickerWithValidation
              v-model="selectedRequiredDate"
              vid="selectedRequiredDate"
              rules="required"
              label="Fecha requerida"
              name="fecha requerida"
              placeholder="Selecciona la fecha"
            />
          </b-col>
          <!-- #endregion::Arrive date picker -->

        </b-form-row>
      </b-card-text>
    </b-card>
    <!-- #endregion::Transfer information -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  BCard, BCardText, BCol, BFormRow,
} from 'bootstrap-vue'

import SelectWithValidation from '@/components/forms/SelectWithValidation.vue'
import DatePickerWithValidation from '@/components/forms/DatePickerWithValidation.vue'

export default {
  components: {
    BCol,
    BCard,
    BFormRow,
    BCardText,
    SelectWithValidation,
    DatePickerWithValidation,
  },
  computed: {
    ...mapGetters({
      getLocations: 'transfers/getLocations',
      getSelectedOrigin: 'transfers/getSelectedOrigin',
      getSelectedDestination: 'transfers/getSelectedDestination',
      getSelectedRequiredDate: 'transfers/getSelectedRequiredDate',

      /**
       * Piezas y circuitos de la orden de traspaso
       */
      getTransferPieces: 'transfers/getTransferPieces',
      getTransferCircuits: 'transfers/getTransferCircuits',

      getLocationTerm: 'products/getLocationTerm',
    }),
    /**
     * Ubicaciones disponibles para el traspaso
     */
    locations: {
      get() { return this.getLocations },
    },
    /**
     * Ubicación de origen seleccionada
     */
    selectedOrigin: {
      get() { return this.getSelectedOrigin },
      set(value) { this.setSelectedOrigin(value) },
    },
    /**
     * Ubicación de destino seleccionada
     */
    selectedDestination: {
      get() { return this.getSelectedDestination },
      set(value) { this.setSelectedDestination(value) },
    },
    /**
     * Fecha requerida seleccionada
     */
    selectedRequiredDate: {
      get() { return this.getSelectedRequiredDate },
      set(value) { this.setSelectedRequiredDate(value) },
    },
    /**
     * Término de búsqueda de ubicaciones
     */
    locationTerm: {
      get() { return this.getLocationTerm },
      set(value) { this.setLocationTerm(value) },
    },
    /**
     * Piezas disponibles para el traspaso
     */
    transferPieces: {
      get() { return this.getTransferPieces },
    },
    /**
     * Circuitos disponibles para el traspaso
     */
    transferCircuits: {
      get() { return this.getTransferCircuits },
    },
    /**
     * Ubicaciones de origen disponibles para el traspaso
     */
    filteredOriginLocations() {
      if (this.selectedDestination) {
        return this.locations.filter(location => location.text !== this.selectedDestination.text)
      }

      return this.locations
    },
    /**
     * Ubicaciones de destino disponibles para el traspaso
     */
    filteredDestinationLocations() {
      if (this.selectedOrigin) {
        return this.locations.filter(location => location.text !== this.selectedOrigin.text)
      }

      return this.locations
    },
    /**
     * Indica si existen productos disponibles para el traspaso
     */
    areAvailableProducts() {
      return this.transferPieces.length > 0 || this.transferCircuits.length > 0
    },
  },
  watch: {
    /**
     * Actualiza la ubicación de origen seleccionada a partir de las piezas de productos
     */
    transferPieces() {
      if (this.transferPieces.length > 0) {
        this.selectedOrigin = { text: this.transferPieces[0].Location }
      } else if (this.transferCircuits.length === 0) {
        this.selectedOrigin = ''
      }
    },
    /**
     * Actualiza la ubicación de origen seleccionada a partir de los circuitos
     */
    transferCircuits() {
      if (this.transferCircuits.length > 0) {
        this.selectedOrigin = { text: this.transferCircuits[0].Location }
      } else if (this.transferPieces.length === 0) {
        this.selectedOrigin = ''
      }
    },
    /**
     * Actualiza el término de búsqueda de ubicaciones a partir de la ubicación
     * de origen seleccionada
     */
    selectedOrigin(newSelectedOrigin) {
      if (!newSelectedOrigin) {
        this.locationTerm = ''
        return
      }

      if (this.selectedDestination && (newSelectedOrigin.text === this.selectedDestination.text)) {
        this.selectedDestination = ''
      }

      this.locationTerm = newSelectedOrigin.text
    },
    /**
     * Actualiza la ubicación de destino seleccionada
     */
    selectedDestination(newSelectedDestination) {
      if (!newSelectedDestination) {
        return
      }

      if (newSelectedDestination.text === this.selectedOrigin.text) {
        this.selectedOrigin = ''
      }
    },
  },
  methods: {
    ...mapActions({
      setLocationTerm: 'products/setLocationTerm',
      setSelectedOrigin: 'transfers/setSelectedOrigin',
      setSelectedDestination: 'transfers/setSelectedDestination',
      setSelectedRequiredDate: 'transfers/setSelectedRequiredDate',
    }),
  },
}
</script>
